import {useQueryClient} from '@tanstack/react-query';
import {apiDelete} from '../../../../../axiosConfig';
import {getStationDevicesApiPath} from '../../../../../react_query/player_device_details/ListStationDevices';
import DialogDelete from '../../../../../components/dialogs/DialogDelete';
import {Button} from '@mui/material';
import {UserCanAny} from '../../../../../components/UserCan';
import {useCallback, useState} from 'react';
import {Logout} from '@mui/icons-material';

type Props = {
  parentStationId: number;
  stationId: number;
  companyId: number;
  rowId: string;
};

const DeleteDeviceBtn: React.FC<Props> = ({
  parentStationId,
  stationId,
  companyId,
  rowId,
}) => {
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const queryClient = useQueryClient();

  const handleRemoveClick = useCallback(() => {
    apiDelete(
      `/v1/company/${companyId}/station/${stationId}/logout-device/${deleteId}`,
    ).then(() => {
      queryClient.invalidateQueries({
        queryKey: [getStationDevicesApiPath(companyId, parentStationId)],
        refetchType: 'active',
      });
      setDeleteId(null);
    });
  }, [
    companyId,
    stationId,
    deleteId,
    queryClient,
    setDeleteId,
    parentStationId,
  ]);

  return (
    <UserCanAny scope='is-admin,player-devices:logout'>
      <>
        <Button
          variant='outlined'
          onClick={() => setDeleteId(rowId)}
          startIcon={<Logout />}>
          Remove & Logout
        </Button>
        {deleteId && (
          <DialogDelete
            successBtnLable='Yes, Remove & Logout'
            handleCancel={() => setDeleteId(null)}
            deleteRow={handleRemoveClick}
          />
        )}
      </>
    </UserCanAny>
  );
};

export default DeleteDeviceBtn;
